import coffeeBean from "./coffee-bean.svg";
import coffeeCup2 from "./coffee-cup-2.svg";
import coffeeCup3 from "./coffee-cup-3.svg";
import coffeeCup5 from "./coffee-cup-5.svg";
import coffeeCupCap from "./coffee-cup-cap.svg";
import coffeeCup from "./coffee-cup.svg";
import coffeeDonut from "./coffee-donut.svg";
import coffeeMaker from "./coffee-maker.svg";
import coffeeMaker2 from "./coffee-maker-2.svg";
import coffeeMug from "./coffee-mug.svg";
import coffeePack from "./coffee-pack.svg";
import coffeePack2 from "./coffee-pack-2.svg";
import coockie from "./coockie.svg";
import greenTeaPack from "./green-tea-pack.svg";
import spoon from "./spoon.svg";
import takeAwayCup from "./take-away-cup.svg";

const coffeeIcons = {
  coffeeBean,
  coffeeCup2,
  coffeeCup3,
  coffeeCup5,
  coffeeCupCap,
  coffeeCup,
  coffeeDonut,
  coffeeMaker,
  coffeeMaker2,
  coffeeMug,
  coffeePack,
  coffeePack2,
  coockie,
  greenTeaPack,
  spoon,
  takeAwayCup
};

export default coffeeIcons;
